import * as React from "react";
import { useNavigate } from "react-router";
import constants from "src/helpers/constants";

const Home = () => {
  const navigate = useNavigate();
  React.useEffect(() => {
    navigate(`/topic/${constants.DEFAULT_TOPIC_ID()}`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <></>;
};

export default Home;
